import Dashboard from "./views/admin/dashboard";
import CatalogNew from "./views/admin/catalogNew";
import CatalogList from "./views/admin/catalogList";

import HomeIcon from '@rsuite/icons/legacy/Charts';
import CatalogIcon from '@rsuite/icons/legacy/Briefcase';
import ListIcon from '@rsuite/icons/legacy/List';

const routes = [
    {
        path: "/dashboard",
        layout: "/admin",
        name: "Panel general",
        icon: <HomeIcon />,
        component: Dashboard,
        role: '',
    },
    {
        path: "/nuevo-filtro",
        layout: "/admin",
        name: "Nuevo catálogo",
        icon: <CatalogIcon />,
        component: CatalogNew,
        role: '',
    },
    {
        path: "/lista-catalogos",
        layout: "/admin",
        name: "Listado de catálogos",
        icon: <ListIcon />,
        component: CatalogList,
        role: '',
    },
];

export default routes;